export enum SignUpType {
	SSO = 'SSO',
	Flink = 'flink',
}
